import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RemoveInfoService {
    private info: Subject<Boolean> = new BehaviorSubject<Boolean>(false);

    get info$() {
        return this.info.asObservable();
    }

    sendOfferID(bool: Boolean) {
        this.info.next(bool);
    }

}